var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid35({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49,12.78V10.37L5.39,7.06H6.75L8.1,9.32,9.42,7.06h1.33L8.64,10.38v2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid35);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_35.0c26c092bb5620db65afa5a1c1679138.svg";
export { ForwardRef as ReactComponent };